import React, { Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import CloseIcon from "../../../../assets/icons/close.svg";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import ProfileWithName from "../ProfileWithName/ProfileWIthName";
// Styles
import "./ApprovalStatus.scss";
import classNames from "classnames";
import { sort } from "fast-sort";

function ApprovalStatus({
  isOpen = false,
  onCloseHandler = () => console.log("No onclose handler provided"),
  approvalLevels = [],
}) {
  const approvedUsers = approvalLevels.filter(
    (user) => user.status === "APPROVED"
  );
  const pendingApprovedUsers = approvalLevels.filter(
    (user) => user.status === "PENDING"
  );
  return (
    <Modal
      show={isOpen}
      dialogClassName={`${"approval-status-modal"}`}
      centered
      onHide={onCloseHandler}
    >
      <Header
        title={"Approval Status"}
        isApproved={pendingApprovedUsers.length === 0}
        onClose={onCloseHandler}
      />
      <Modal.Body className="approval-status-modal-body">
        {approvedUsers.length > 0 && (
          <Fragment>
            <Typography className="approval-status-label mb-4">
              {"Approved By"}
            </Typography>
            {sort(approvedUsers)
              .asc((u) => Number(u.levelOrder))
              .map((user) => (
                <UserProfileCard user={user} />
              ))}
          </Fragment>
        )}
        {pendingApprovedUsers.length > 0 && (
          <Fragment>
            <Typography className="approval-status-label mb-4">
              {"Pending Approval"}
            </Typography>
            {sort(pendingApprovedUsers)
              .asc((u) => Number(u.levelOrder))
              .map((user) => (
                <UserProfileCard user={user} />
              ))}
          </Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-secondary"
          data-dismiss="modal"
          onClick={onCloseHandler}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

ApprovalStatus.propTypes = {
  isOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  approvalLevels: PropTypes.arrayOf(PropTypes.object),
};

export default ApprovalStatus;
// Helper component
const Header = ({ title, isApproved, onClose }) => (
  <Modal.Header className="d-flex justify-content-between align-items-center">
    <div>
      <h4 className="modal-title">{title}</h4>
    </div>
    <div className="d-flex align-items-center">
      <div
        className={classNames({
          "btn-active w-100": isApproved,
          "btn-pending": !isApproved,
        })}
      >
        {isApproved ? "APPROVED" : "PENDING"}
      </div>
      <img
        className="close"
        src={CloseIcon}
        alt="closeIcon"
        onClick={onClose}
      />
    </div>
  </Modal.Header>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const UserProfileCard = ({ user }) => {
  return (
    <Card className="mb-4">
      <CardContent className="d-flex align-items-center justify-content-between">
        <ProfileWithName
          sKey={user.id}
          nameIntial={getInitials(user.firstName, user.lastName)}
          personName={`${user.firstName} ${user.lastName}`}
          profile={user.imageUrl}
          isPopover={false}
        />
        <Typography className="approval-status-label">
          {`${user.name}`}
        </Typography>
      </CardContent>
    </Card>
  );
};

UserProfileCard.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    nameInitial: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }).isRequired,
};

// Helper functions
function getInitials(firstName, lastName) {
  // If both first and last names are empty, return "AA"
  if (!firstName && !lastName) {
    return "AA";
  }

  // If either first or last name is empty, append "A" for the missing one
  const firstInitial = firstName ? firstName[0].toUpperCase() : "A";
  const lastInitial = lastName ? lastName[0].toUpperCase() : "A";

  return `${firstInitial}${lastInitial}`;
}
